<template>
  <!-- <div id="bottom">
    <p>2018-2024 <a href="http://www.miit.gov.cn/">浙ICP备19002453号</a> 杭州首秀网络科技有限公司</p>
    <p>版权归 杭州首秀网络科技有限公司 所有</p>
    <p>联系方式 superadmin@shangnide.com</p>
    <div style="width:300px;margin:0 auto;padding-bottom: 20px; display: flex;align-items: center;justify-content: center;">
        <img src="../assets/beianIcon.png" alt="" style="width:20px;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602009939" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙公网安备 33010602009939号</p></a>
    </div>
  </div> -->
  <div id="bottom">
    <p>2018-2024 <a href="http://www.miit.gov.cn/">浙ICP备2021015330号</a> 杭州缘分网络科技有限公司</p>
    <p>版权归 杭州缘分网络科技有限公司 所有</p>
    <p>联系方式 superadmin@shangnide.com</p>
    <div style="width:300px;margin:0 auto;padding-bottom: 20px; display: flex;align-items: center;justify-content: center;">
        <img src="../assets/beianIcon.png" alt="" style="width:20px;">
        <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33010602009939" style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">浙公网安备 33010602009939号</p></a>
    </div>
  </div>
</template>

<script>

import '../sass/bottom.min.css'

export default {
  name:'bottom',
  data(){
    return{
      
    }
  },
  methods:{

  },
  mounted(){

  }
}
</script>